import type {
  DAPerformanceTrackLine,
  DAPerformanceTrackFilters,
  DAPerformanceTrackMonthlySummaryFilters,
  DAPerformanceTrackMonthlySummary,
} from '@/types/eos/DARTPerformanceTracker'
import axios from 'axios'

export async function getDAPerformanceTrack(options: DAPerformanceTrackFilters): Promise<DAPerformanceTrackLine[]> {
  const response = await axios.get(`${import.meta.env.VITE_APP_EOSS_API}/pr-performance-tracker`, { params: options })
  return response.data
}

export async function getDAPerformanceTrackMonthlySummary(
  options: DAPerformanceTrackMonthlySummaryFilters
): Promise<DAPerformanceTrackMonthlySummary> {
  const response = await axios.get(`${import.meta.env.VITE_APP_EOSS_API}/pr-performance-tracker/monthly`, {
    params: options,
  })
  return response.data
}
